import React, { Component } from "react";
import { Chip, Grid, Snackbar, Typography } from "@mui/material";
import { Product, ProductOption } from "../../../classes/types/product/product";
import currency from "currency.js";
import standardImage from "../../../assets/defaultImage.jpg";
import { euroPrint } from "../../../classes/types/currencysettings";
import { LocalOffer } from "@mui/icons-material";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDolly } from "@fortawesome/free-solid-svg-icons";
import dayjs from "dayjs";
import MoneyOffIcon from '@mui/icons-material/MoneyOff';
interface props {
  product: Product;
  isLogged: boolean;
  searchedInput: string;
}

interface state {
  openSnackBar: boolean;
  productOptions: Array<ProductOption>;
}

export default class SearchCard extends Component<props, state> {
  constructor(props: props) {
    super(props);
    this.state = {
      openSnackBar: false,
      productOptions: new Array<ProductOption>(),
    };
  }

  componentDidMount() {
    /*  ProductHandler.getProductOptions(this.props.product.id).then((newProductOptions) => {
            this.setState({
                productOptions: newProductOptions,
            })
        }).catch(() => {

        })*/
  }

  render() {
    return (
      <div style={{ width: "100%" }}>
        <div style={{ height: "100%", cursor: "pointer" }}>
          <Link
            to={
              `/shop/cerca/` +
              encodeURIComponent(this.props.searchedInput) +
              `/page/1/prodotto/` +
              this.props.product.id
            }
          >
            <Grid container>
              <Grid
                style={{
                  overflow: "hidden",
                  maxWidth: "100%",
                  height: "130px",
                }}
                direction={"column"}
                xs={2}
                justifyContent={"center"}
                alignContent={"center"}
                item
                container
              >
                <div
                  style={{
                    padding: "5%",
                    overflow: "hidden",
                    cursor: "pointer",
                  }}
                >
                  {
                    <img
                      style={{
                        cursor: "pointer",
                        height: "100%",
                        width: "100%",
                        objectFit: "contain",
                      }}
                      alt={"ciao"}
                      src={this.props.product.images.length > 0 ? this.props.product.images[0].link : standardImage}
                    />
                  }
                </div>
              </Grid>
              <Grid
                alignContent={"flex-start"}
                direction={"column"}
                xs={7}
                item
                container
              >
                <Typography
                  variant="subtitle1"
                  style={{ marginTop: "10px", textAlign: "left" }}
                  component="h2"
                >
                  <div style={{ cursor: "pointer" }}>
                    <b>{this.props.product.name}</b>
                  </div>
                </Typography>
                <Typography
                  style={{ textAlign: "left" }}
                  variant="subtitle2"
                  component="h2"
                >
                  <i>Codice: {this.props.product.sku}</i>
                </Typography>
                {!this.props.product.configurable && this.props.isLogged ? <Typography
                  style={{
                    textAlign: "left",
                    color: this.props.product.stock1 > 0 ? "green" : "darkred",
                  }}
                  variant="subtitle2"
                  component="h2"
                >
                  Rimanenti in magazzino: {this.props.product.stock1} pezzi
                </Typography> : ""}
                <div
                  style={{
                    textAlign: "left",
                    marginTop: "auto",
                    marginBottom: "10px",
                  }}
                >
                  <br />
                  {this.props.product.maker !== "" ? (
                    <Chip
                      size="small"
                      icon={<LocalOffer />}
                      color="primary"
                      style={{
                        marginRight: "5px",
                        marginTop: "5px",
                        paddingLeft: "10px",
                        paddingRight: "10px",
                      }}
                      label={this.props.product.maker}
                    />
                  ) : (
                    ""
                  )}
                  {this.props.product.arrivingQuantity > 0 && this.props.isLogged ? (
                    <Chip
                      size="small"
                      icon={<FontAwesomeIcon icon={faDolly} />}
                      style={{
                        marginRight: "5px",
                        marginTop: "5px",
                        paddingLeft: "10px",
                        paddingRight: "10px",
                      }}
                      label={"In arrivo " +
                        this.props.product.arrivingQuantity +
                        (this.props.product.arrivingQuantityDate !== "" ? dayjs(this.props.product.arrivingQuantityDate, "YYYY-MM-DD").isSame(dayjs()) || dayjs(this.props.product.arrivingQuantityDate, "YYYY-MM-DD").isBefore(dayjs()) ? " durante la giornata odierna" : " dal " + dayjs(this.props.product.arrivingQuantityDate, "YYYY-MM-DD").format("DD/MM/YYYY") : "")}
                    />
                  ) : (
                    ""
                  )}
                  {this.props.product.status.toLowerCase() === 'in esaurimento' ? <Chip
                    size="small"
                    icon={<MoneyOffIcon style={{ color: "white" }} />}
                    style={{
                      marginRight: "5px",
                      marginTop: "5px",
                      paddingLeft: "10px",
                      paddingRight: "10px",
                      backgroundColor: "green",
                      color: "white"
                    }}
                    label={"In Promozione"}
                  /> : ""}
                </div>
              </Grid>
              <Grid direction={"column"} xs={3} item container>
                {this.props.product.configurable ?
                  <Typography
                    variant="subtitle1"
                    style={{
                      fontSize: "1.2rem",
                      marginTop: "10px",
                      textAlign: "right",
                      marginRight: "2%",
                    }}
                    component="h1"
                  >
                    Configura per visualizzare il prezzo
                  </Typography> : !this.props.isLogged ? (
                    <Typography
                      variant="subtitle1"
                      style={{
                        fontSize: "1.2rem",
                        marginTop: "10px",
                        textAlign: "right",
                        marginRight: "2%",
                      }}
                      component="h1"
                    >
                      <Link to={"/login"}>Accedi per visualizzare il prezzo</Link>
                    </Typography>
                  ) : (
                    <Typography
                      variant="subtitle1"
                      style={{
                        fontSize: "1.5rem",
                        marginTop: "10px",
                        textAlign: "right",
                        marginRight: "2%",
                      }}
                      component="h1"
                    >
                      <b style={{ whiteSpace: "nowrap" }}>
                        <span
                          style={{
                            textDecoration:
                              this.props.product.discountedPrice !== undefined
                                ? "line-through"
                                : "",
                          }}
                        >
                          {euroPrint(this.props.product.price)}
                        </span>
                        <b>
                          <span
                            style={{ color: "#b3071b", marginLeft: "10px" }}
                            hidden={
                              this.props.product.discountedPrice === undefined
                            }
                          >
                            {currency(this.props.product.discountedPrice, {
                              symbol: "€",
                            }).format()}
                          </span>
                        </b>
                      </b>
                      {this.props.product.discountedPrice !== undefined ? (
                        <Typography variant="subtitle2">
                          <b>
                            Risparmi il{" "}
                            <span
                              style={{
                                padding: "1%",
                                backgroundColor: "#b3071b",
                                color: "white",
                              }}
                            >
                              {Math.round(
                                ((this.props.product.price -
                                  this.props.product.discountedPrice) /
                                  this.props.product.price) *
                                100
                              )}
                              %
                            </span>{" "}
                            sul prezzo di listino
                          </b>
                        </Typography>
                      ) : (
                        ""
                      )}
                    </Typography>
                  )}
              </Grid>
            </Grid>
          </Link>
        </div>

        <Snackbar
          anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
          open={this.state.openSnackBar}
          onClose={this.handleCloseSnack}
          message={this.props.product.name + " aggiunto al carrello"}
        />
      </div>
    );
  }

  handleCloseSnack = () => {
    this.setState({
      openSnackBar: false,
    });
  };
}
